export default "__VITE_ASSET__CB1Z5n02__"